const DEBUGGING: boolean = process.env.NODE_ENV === 'development'

import { BaseObject, MongoObject } from './_baseClasses'
import { Moment } from './Moment';
import { TokenUser } from './TokenUser';
import * as telegram from "./telegram"
import * as utils from "./utils"
import * as utils_time from "./utils_time"
import * as utils_topshot from "./utils_topshot"
import { Auction } from './Auction';

export class Deal extends Moment {
  public price: number = null
  public dateListed: Date = null
  public seller: string = null

  public dealRating: number = null
  public profitMargin: number = null
  public lowestAsk: number = null

  public gone: boolean = null
  public goneInSec: number = null

  public auction: Auction = null    // if it's an auction

  public numClicks: number = null

  // March 14, 2024
  public flowtyListingResourceID: number  = null    // null if not flowty

  // client only
  public listedAgo: string = null

  // complex, class-based fields (require to be hydrated after loading from external sources like mongo or elastic)

  constructor(po?: object) {
    super(po)
    if (po) this.injectPlainObject(po)

    this.hydrate()
  }

  protected hydrate(): void {
    super.hydrate()
    if (typeof this.dateListed === 'string') this.dateListed = new Date(this.dateListed)

    // @ts-ignore
    if (this.auction) this.auction = new Auction(this.auction)
  }

  public isSafe(): boolean {
    if (!super.isSafe()) return false
    return true
  }

  public setListedAgo() {
    const nowTimeMS: number = new Date().getTime() + utils.getMsTimeServerIsAhead()
    this.listedAgo = this.dateListed ? utils_time.prettyTimeDiff(nowTimeMS - this.dateListed.getTime()) + ' ago' : '?'
  }

  public getDealRatingString(): string {
    return '🔥'.repeat(this.dealRating)
  }
  public getDealRatingHTML(): string {
    if (this.dealRating < 1) return '+'
    const oneFlame: string = '<img class="dealFlame" src="/images/flame_emoji_32x41.png" />'
    return oneFlame.repeat(this.dealRating)
  }
  public getLiquidityRatingHTML(): string {
    const oneDroplet: string = '<img class="dealDroplet" src="/images/droplet_emoji_32x41.png" />'
    let liquidityRating: number = this.liquidityRating || Math.round(Math.pow(this.numSales, 0.40) - 1)
    if (liquidityRating > 5) liquidityRating = 5
    if (liquidityRating <= 0) return ''
    return oneDroplet.repeat(liquidityRating)
  }

  public getBuyURL(): string {
    // March 14, 2024
    const flowtySuffix: string = this.flowtyListingResourceID ? `&flowty=${this.flowtyListingResourceID}` : ''

    // Jan 22, 2024
    return `https://livetoken.co/goto/moment/${this.momentID}?type=0&value=${this.price}${flowtySuffix}`
    // return this.getTopShotLink(true)
  }

  public getGoneURL(): string {
    // March 14, 2024
    const flowtySuffix: string = this.flowtyListingResourceID ? `&flowty=${this.flowtyListingResourceID}` : ''

    // Jan 22, 2024
    return `https://livetoken.co/goto/moment/${this.momentID}?type=1&value=${this.price}${flowtySuffix}`
    // return this.getTopShotLink(true)
  }

  public getBuyButtonVariant(user: TokenUser): string {
    if (this.auction) return 'info'
    if (this.momentGUID) return 'success'
    if (user && user._temp.account && user._temp.account.flowAddress === '1c5df82849b33941') return 'primary'
    return 'success'
  }

  public isLowestAsk(): boolean {
    return (this.price <= this.lowestAsk)
  }

  public getClassNameBasedOnPrice(): string {
    if (this.isLowestAsk()) return 'lowestAsk'
    return 'regularAsk'
  }
}




(async () => {
})();
